import * as administrator from './administrator';
import * as company       from './company'      ;
import * as common        from './common'       ;

type TypeGet = {
  administrator: typeof administrator;
  company      : typeof company      ;
  common       : typeof common       ;
}

const get: TypeGet = {
  administrator,
  company      ,
  common       ,
};

export default get;
